import { render, staticRenderFns } from "./history-work-order.vue?vue&type=template&id=12751c1f&scoped=true"
import script from "./history-work-order.vue?vue&type=script&lang=ts"
export * from "./history-work-order.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12751c1f",
  null
  
)

export default component.exports